import { FormArray, FormGroup } from '@angular/forms';
import { GlobalService } from './global.service';
import { translate } from '@jsverse/transloco';

/**
 * generate the form validation errors
 * @param form 
 * @param globalService 
 * @param role_name 
 */
export function getFormValidationErrors(form: FormArray, globalService: GlobalService, role_name: string = '') {
    form.controls.forEach((element: FormGroup) => {
        if (element.status == "INVALID") {
            if (element.controls.value.status == "INVALID") {
                const errors = element.controls.value.errors;
                const fieldname = element.value.translation;
                for (const key in errors) {
                    if (key == 'pattern') {
                        showErrorToast(validatePattern(errors[key], translate(fieldname), role_name), globalService);
                    }
                    else {
                        showErrorToast(getErrorMessage(key, translate(fieldname), role_name), globalService);
                    }
                }
            }
        }
    });
}



/**
 * init the validation function to get the errors 
 * @param templateFormControls 
 * @param globalService 
 */
export function initValidationForRecipientTabs(templateFormControls, globalService: GlobalService) {
    const templateRolesControls = (templateFormControls.template_roles as FormArray);
    if(templateRolesControls.length == 0 && templateRolesControls?.errors){
        showErrorToast(templateRolesControls?.errors?.error, globalService);
    }
    else if(templateRolesControls?.errors?.invalidOrderSequence){
        showErrorToast(translate('Invitation order toaster message (Send document section) - Invitation order must be in squence'), globalService);
    }else if(templateRolesControls?.errors?.invalidInvitationOrder){
        showErrorToast(translate('Invitation order toaster message (Send document section) - Invitation order must be unique and sequential'), globalService);
    }else if(templateRolesControls?.errors?.multipleSameDeviceNotAllowed || templateRolesControls?.errors?.sameDeviceMustBeFirst){
        showErrorToast(translate('Invitation order toaster message (Send document section) - Only one recipient and the first in order can have invitation method same device'), globalService);
    }
    templateRolesControls.controls.forEach((element: FormGroup) => {
        if(element.controls.recipient_id.status == "INVALID"){
            showErrorToast(getErrorMessage('recipient_required', 'Recipient', element.value.role_name), globalService);
        }else{
            getFormValidationErrors(element.controls.personfields as FormArray, globalService, element.value.role_name);
            getFormValidationErrors(element.controls.orgfields as FormArray, globalService, element.value.role_name);   
        }
    });
}

export function getRoleValidationBeforeSign(roleForm: FormArray, globalService: GlobalService, role_name: string = '') {
    let validate:boolean = false;
    const templateRolesControls = roleForm.controls;
    templateRolesControls.forEach((element: FormGroup) => {
        const personfields = element.controls.personfields as FormArray;
        const orgfields = element.controls.orgfields as FormArray
        personfields.controls.forEach((personField: FormGroup) => {
            // Use getRawValue so disabled child controls (like 'value') are included
            const fieldRaw = personField.getRawValue();
            if(!fieldRaw.value && fieldRaw.required === 1 && fieldRaw.is_enable === 1 && fieldRaw.lock === 0){
                validate = true;
                showErrorToast(getErrorMessage('required', translate(fieldRaw.translation), role_name), globalService);
            }
        });
        orgfields.controls.forEach((orgFields: FormGroup) => {
            // Use getRawValue so disabled child controls (like 'value') are included
            const fieldRaw = orgFields.getRawValue();
            if(!fieldRaw.value && fieldRaw.required === 1 && fieldRaw.is_enable === 1 && fieldRaw.lock === 0){
                validate = true;
                showErrorToast(getErrorMessage('required', translate(fieldRaw.translation), role_name), globalService);
            }
        });
    });
    return {validate: validate};
}

/**
 * use form the pattern validation, ex: custom validation Regex
 * @param error 
 * @param fieldname 
 * @param role_name 
 */
export function validatePattern(error, fieldname: string, role_name: string = '') {
    let pattern = error.requiredPattern.toString().slice(1, -1);
    pattern = new RegExp(pattern);
    if (!pattern.test(error.actualValue)) {
        return translate("Field required (form validation) - Field name has invalid value in role", {fieldname:fieldname, role:role_name});
    }
}




/**
 * get the error message
 * @param key 
 * @param fieldname 
 * @param role_name 
 */
export function getErrorMessage(key: string, fieldname: string, role_name: string = '') {
    if (key == 'invalidDecimalPlaces') {
        return translate("Field required (form validation) - Field name has invalid decimals in role", {fieldname:fieldname, role:role_name});
    } else if (key == 'outOfRange') {
        return translate("Field required (form validation) - Field name has invalid value in role", {fieldname:fieldname, role:role_name});
    } else if (key == 'maxlength' || key == 'invalidNumber') {
        return translate("Field required (form validation) - Field name has invalid value in role", {fieldname:fieldname, role:role_name});
    } else if (key == 'required') {
        return translate("Field required (form validation) - Field name is required in role", {fieldname:fieldname, role:role_name});
    } else if (key == 'invalidPersonNummer') {
        return translate("Field required (form validation) - Personal number is invalid in role", {role:role_name});
    } else if (key == 'invalidPhoneNo' || key === 'validatePhoneNumber') {
        return translate("Field required (form validation) - Phone number is invalid in role", {role:role_name});
    } else if (key == 'recipient_required') {
        return translate("Field required (form validation) - Add recipient in role", {role:role_name})
    }
    return '';
}



/**
 * show the error toast
 * @param message 
 * @param globalService 
 */
export function showErrorToast(message: string, globalService: GlobalService) {
    globalService.toastrError(message);
}


